import { Text } from "@shopify/polaris"
import classNames from "classnames"
import { observer } from "mobx-react"

import ProtectionCard from "@/pages/FreeReturnservice/ProtectionCard"

// 自定义InfoIcon弹窗组件
const FreeReturnServiceWidgetModal = ({
  isOpen,
  onClose,
  md,
}: {
  isOpen: boolean
  md: boolean
  onClose: () => void
}) => {
  if (!isOpen) return null

  return (
    <>
      {/* 遮罩层 */}
      <div
        className="fixed inset-0 z-[999]"
        onClick={onClose}
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          pointerEvents: "auto",
          mixBlendMode: "normal",
          boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.5)",
        }}
      />

      {/* 弹窗容器 - 定位在按钮下方 */}
      <div
        className={classNames({
          relative: md,
          "fixed inset-0 flex items-center justify-center z-[1000]": !md,
        })}
      >
        <div
          className={classNames({
            "z-[1000] absolute top-[8px] right-[-40px]": md,
          })}
        >
          <div className="relative">
            {/* 弹窗内容 */}
            <div
              className={classNames(
                "bg-white rounded-lg shadow-lg relative max-w-[652px] md:w-[652px]",
              )}
              style={{
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
              }}
            >
              <div className="p-4">
                <ProtectionCard cart_insurance_enable={0} showInBilling />
              </div>
              <div style={{ borderTop: "1px solid #e1e2e3" }}></div>
              <div className="p-4">
                <Text variant="bodySm" as="span" tone="subdued">
                  {t("GrowYourRevenueWhileCoveringYourRe")}
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default observer(FreeReturnServiceWidgetModal)
